// extracted by mini-css-extract-plugin
export default {"sidebar":"leftNav_sidebar__kfVJv","hideSidebar":"leftNav_hideSidebar__3Tkky","hideSections":"leftNav_hideSections__-Ihy0","bottomNav":"leftNav_bottomNav__hKLBf"};